var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocusEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 13.6C14.3118 13.6 14.8888 13.0229 14.8888 12.3111C14.8888 11.5993 14.3118 11.0222 13.5999 11.0222C12.8881 11.0222 12.311 11.5993 12.311 12.3111C12.311 13.0229 12.8881 13.6 13.5999 13.6Z",
    stroke: "#00848D",
    strokeWidth: 2.175
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6252 11.5128C21.7911 11.8395 21.8739 12.0028 21.8739 12.3112C21.8739 12.6197 21.7911 12.783 21.6252 13.1097C20.8178 14.6999 18.5132 18.1112 13.5999 18.1112C8.68666 18.1112 6.38203 14.6999 5.57462 13.1097C5.40878 12.783 5.32587 12.6197 5.32587 12.3112C5.32587 12.0028 5.40878 11.8395 5.57462 11.5128C6.38203 9.92253 8.68666 6.51123 13.5999 6.51123C18.5132 6.51123 20.8178 9.92253 21.6252 11.5128Z",
    stroke: "#00848D",
    strokeWidth: 2.175
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0444 2H20.3022C22.611 2 23.7655 2 24.4827 2.71727C25.2 3.43452 25.2 4.58894 25.2 6.89778V7.15556M20.0444 22.6222H20.3022C22.611 22.6222 23.7655 22.6222 24.4827 21.905C25.2 21.1877 25.2 20.0332 25.2 17.7244V17.4667M7.15556 2H6.89778C4.58894 2 3.43452 2 2.71727 2.71727C2 3.43452 2 4.58894 2 6.89778V7.15556M7.15556 22.6222H6.89778C4.58894 22.6222 3.43452 22.6222 2.71727 21.905C2 21.1877 2 20.0332 2 17.7244V17.4667",
    stroke: "#00848D",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusEye);
export default __webpack_public_path__ + "static/media/focus-eye.bd305f2785039f776e65b75f05682232.svg";
export { ForwardRef as ReactComponent };